export const getQuery = (header: string | Array<string> | undefined) => (Array.isArray(header) ? header[0] : header)
